var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGondola(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 17,
    viewBox: "0 0 89 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.956 12.233H20.963v.35h47.993v-.35z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.216 12.49v-1.358h-.35v1.358h.35zM26.352 12.492v-1.358h-.35v1.358h.35zM28.486 12.492v-1.358h-.349v1.358h.35zM61.405 10.281h-.373v2.09h.373v-2.09zM63.173 10.281h-.372v2.09h.372v-2.09z",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.128 11.854H52.835v.212h14.293v-.213zM41.886 11.4H24.17v.233h17.716v-.234z",
    fill: "gray"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.844 11.855h2.517c.11 0 .198.089.198.198v1.174a.198.198 0 0 1-.198.198h-2.517a.198.198 0 0 1-.197-.198v-1.174c0-.109.088-.198.197-.198z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.56 12.053v.265h-2.913v-.265c0-.109.088-.198.197-.198h2.517c.11 0 .198.089.198.198h.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.56 12.962v.265a.198.198 0 0 1-.197.198h-2.517a.198.198 0 0 1-.198-.198v-.265h2.914-.001z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.732 9.944h-.373v2.09h.373v-2.09zM45.499 9.944h-.373v2.09h.373v-2.09z",
    fill: "#666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.171 11.519h2.517c.11 0 .198.088.198.197v1.175a.198.198 0 0 1-.198.197h-2.517a.198.198 0 0 1-.197-.197v-1.175c0-.109.088-.197.197-.197z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.886 11.716v.266h-2.914v-.266c0-.109.088-.197.197-.197h2.518c.108 0 .197.088.197.197h.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.886 12.625v.265a.198.198 0 0 1-.198.198h-2.517a.198.198 0 0 1-.197-.197v-.266h2.914-.002z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.343 9.77H19.606v2.004h10.737V9.77zM69.431 9.77H54.766v2.004H69.43V9.77z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.822 10.254c.72.203 1.452.4 2.13.74.682.334 1.293.834 1.722 1.466l-.142.097a4.17 4.17 0 0 0-.733-.814 4.654 4.654 0 0 0-.92-.602c-.66-.33-1.378-.542-2.1-.727l.043-.16z",
    fill: "#4D4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m89 12.812-.07-.101-.089.062.07.1.09-.061zM88.83 12.929l-.07-.1-.09.061.07.1.09-.061z",
    fill: "#CCC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m88.768 12.39.222.319-.348.242-.222-.319a.116.116 0 0 1 .029-.161l.16-.11a.116.116 0 0 1 .16.028h-.001zM5.399 10.254c-.72.203-1.452.4-2.131.74a4.439 4.439 0 0 0-1.721 1.466l.141.097c.208-.301.453-.577.734-.814.279-.236.59-.437.919-.602.66-.33 1.379-.542 2.1-.727l-.042-.16z",
    fill: "#4D4D4D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m1.313 12.875.07-.1-.09-.063-.07.1.09.063zM1.477 12.988l.07-.1-.09-.063-.07.101.09.062z",
    fill: "#CCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m1.795 12.633-.222.319-.348-.242.222-.319a.116.116 0 0 1 .161-.029l.16.111a.116.116 0 0 1 .028.161h-.001z",
    fill: "#4D4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.437 10.354h-1.035v2.09h1.035v-2.09zM36.03 10.354h-1.035v2.09h1.035v-2.09zM42.298 10.354h-1.035v2.09h1.035v-2.09z",
    fill: "#666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.578 10.809h1.575a.373.373 0 0 0 .372-.373V9.27a.373.373 0 0 0-.372-.373h-1.575a.373.373 0 0 0-.373.373v1.166c0 .206.167.373.373.373z",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.22 9.161a.384.384 0 0 1 .11-.017h1.574c.206 0 .372.167.372.373v1.166a.372.372 0 0 1-.015.107.373.373 0 0 0 .262-.356V9.268a.373.373 0 0 0-.373-.372h-1.576a.374.374 0 0 0-.357.263l.003.002z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m84.73 10.136 3.121.184a.278.278 0 0 0 .293-.276v-.463a.276.276 0 0 0-.293-.276l-3.121.184v.649-.002z",
    fill: "#4D4D4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m87.185 9.74.617-.005v-.277l-.617.026v.257zM86.445 9.748l.506-.006v-.25l-.506.02v.236zM85.833 9.752l.42-.003V9.52l-.42.017v.214zM85.315 9.758l.356-.004v-.21l-.356.016v.198zM87.185 10.137l.617.025v-.277l-.617-.005v.257zM86.445 10.108l.506.02v-.25l-.506-.005v.235zM85.833 10.083l.42.017v-.228l-.42-.004v.215zM85.315 10.06l.356.016v-.21l-.356-.003v.198zM88.031 10.99h-.199a.173.173 0 0 1-.173-.174v-.126h.546v.126a.173.173 0 0 1-.174.173zM87.143 10.99h-.2a.173.173 0 0 1-.173-.174v-.126h.546v.126a.173.173 0 0 1-.173.173zM1.3 10.611l-.67-.31a.202.202 0 0 1-.118-.183v-.53a.2.2 0 0 1 .117-.183l.67-.31v1.516z",
    fill: "#333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.3 9.095v.098l-.562.26a.228.228 0 0 0-.133.207v.596c0 .011.002.023.004.035a.204.204 0 0 1-.097-.172V9.59c0-.08.046-.15.117-.184l.67-.308v-.003z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.522 9.187v1.334c0 .158-.13.288-.288.288H1.42a.287.287 0 0 1-.196-.077.284.284 0 0 1-.095-.213V9.185c0-.16.13-.29.29-.29h.815a.287.287 0 0 1 .287.292h.002z",
    fill: "#333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.513 9.12H1.49c-.148 0-.267.201-.267.446v1.168a.284.284 0 0 1-.095-.213V9.187c0-.16.13-.29.29-.29h.815c.136 0 .25.096.279.223h.001z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m4.87 10.136-3.122.184a.278.278 0 0 1-.293-.276v-.463c0-.16.135-.286.293-.276l3.122.184v.649-.002z",
    fill: "#4D4D4D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m2.415 9.74-.618-.005v-.277l.618.026v.257zM3.153 9.748l-.506-.006v-.25l.506.02v.236zM3.766 9.752l-.42-.003V9.52l.42.017v.214zM4.283 9.758l-.355-.004v-.21l.355.016v.198zM2.415 10.137l-.618.025v-.277l.618-.005v.257zM3.153 10.108l-.506.02v-.25l.506-.005v.235zM3.766 10.083l-.42.017v-.228l.42-.004v.215zM4.283 10.06l-.355.016v-.21l.355-.003v.198z",
    fill: "#333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.41 11.774H69.63l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#666"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.41 11.774H69.63l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.41 11.492H69.63L65.23 10.07h18.578l-4.398 1.422z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.573 8.682h-6.105v2.86h6.105v-2.86z",
    fill: "#1A1A1A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.021 11.259H70.02a.826.826 0 0 0-.826.825v.996c0 .456.37.826.826.826h9.002c.456 0 .826-.37.826-.826v-.996a.826.826 0 0 0-.826-.825z",
    fill: "#333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 16.142a2.752 2.752 0 1 0 0-5.504 2.752 2.752 0 0 0 0 5.504z",
    fill: "gray"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 15.926a2.536 2.536 0 1 0 0-5.072 2.536 2.536 0 0 0 0 5.072z",
    fill: "#4D4D4D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 15.157a1.767 1.767 0 1 0 0-3.534 1.767 1.767 0 0 0 0 3.534z",
    fill: "#333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 13.943a.553.553 0 1 0 0-1.106.553.553 0 0 0 0 1.106z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.689 16.142a2.752 2.752 0 1 0 0-5.504 2.752 2.752 0 0 0 0 5.504z",
    fill: "gray"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.689 15.926a2.536 2.536 0 1 0 0-5.073 2.536 2.536 0 0 0 0 5.073z",
    fill: "#4D4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.689 15.157a1.767 1.767 0 1 0 0-3.534 1.767 1.767 0 0 0 0 3.534z",
    fill: "#333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.242 13.39a.553.553 0 1 1-1.106 0 .553.553 0 0 1 1.106 0zM74.434 12.843h-1.678v.255h1.678v-.255zM74.434 13.3h-1.678v.256h1.678v-.255zM74.434 12.384h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m74.436 12.64-1.68.472v-.255l1.68-.473v.255z",
    fill: "gray"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.434 13.76h-1.678v.256h1.678v-.255zM74.434 14.227h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m74.436 13.098-1.68.472v-.256l1.68-.471v.255zM74.436 13.556l-1.68.473v-.255l1.68-.473v.255zM74.436 14.016l-1.68.472v-.256l1.68-.471v.255z",
    fill: "gray"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.434 11.926h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m74.436 12.181-1.68.473v-.257l1.68-.471v.255z",
    fill: "gray"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.283 12.843h-1.678v.255h1.678v-.255zM76.283 13.3h-1.678v.256h1.678v-.255zM76.283 12.384h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m76.283 12.64-1.678.472v-.255l1.678-.473v.255z",
    fill: "gray"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.283 13.76h-1.678v.256h1.678v-.255zM76.283 14.227h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m76.283 13.098-1.678.472v-.256l1.678-.471v.255zM76.283 13.556l-1.678.473v-.255l1.678-.473v.255zM76.283 14.016l-1.678.472v-.256l1.678-.471v.255z",
    fill: "gray"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.283 11.926h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m76.283 12.181-1.678.473v-.257l1.678-.471v.255z",
    fill: "gray"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M80.93 11.935a.858.858 0 0 0-.598-.314l-3.72-.282h-4.184l-3.721.282a.851.851 0 0 0-.746 1.119l.273.823h2.711l1.039 1.17a.817.817 0 0 0 .609.274h3.855c.233 0 .455-.1.61-.274l1.038-1.17h2.711l.273-.823a.85.85 0 0 0-.148-.805h-.002zm-9.016 1.194a.199.199 0 0 1-.319.159l-.966-.73v-.431c0-.092.075-.167.166-.167h.952c.092 0 .167.075.167.167v1.002zm4.493.913c0 .19-.154.347-.347.347h-3.082a.348.348 0 0 1-.348-.347v-1.735c0-.19.155-.347.348-.347h3.082c.19 0 .347.155.347.347v1.735zm2.002-1.484-.967.73a.199.199 0 0 1-.318-.159v-1.002c0-.092.075-.167.167-.167h.951c.092 0 .167.075.167.167v.43z",
    fill: "gray"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.794 12.767h-.887a.179.179 0 0 0-.178.178v.887c0 .099.08.179.178.179h.887c.099 0 .179-.08.179-.179v-.887a.179.179 0 0 0-.179-.178zM80.133 12.767h-.887a.179.179 0 0 0-.179.178v.887c0 .099.08.179.18.179h.886c.099 0 .179-.08.179-.179v-.887a.179.179 0 0 0-.18-.178z",
    fill: "#4D4D4D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M19.409 11.774H9.627l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#666"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.409 11.774H9.627l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.409 11.492H9.627L5.229 10.07h18.578l-4.398 1.422z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.571 8.682h-6.105v2.86h6.105v-2.86z",
    fill: "#1A1A1A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M19.02 11.259h-9.003a.826.826 0 0 0-.826.825v.996c0 .456.37.826.826.826h9.003c.455 0 .825-.37.825-.826v-.996a.826.826 0 0 0-.825-.825z",
    fill: "#333"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.349 16.142a2.752 2.752 0 1 0 0-5.504 2.752 2.752 0 0 0 0 5.504z",
    fill: "gray"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.349 15.926a2.536 2.536 0 1 0 0-5.072 2.536 2.536 0 0 0 0 5.072z",
    fill: "#4D4D4D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.349 15.157a1.767 1.767 0 1 0 0-3.534 1.767 1.767 0 0 0 0 3.534z",
    fill: "#333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 13.943a.553.553 0 1 0 0-1.106.553.553 0 0 0 0 1.106z",
    fill: "#4D4D4D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 16.142a2.752 2.752 0 1 0 0-5.504 2.752 2.752 0 0 0 0 5.504z",
    fill: "gray"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 15.926a2.536 2.536 0 1 0 0-5.073 2.536 2.536 0 0 0 0 5.073z",
    fill: "#4D4D4D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 15.157a1.767 1.767 0 1 0 0-3.534 1.767 1.767 0 0 0 0 3.534z",
    fill: "#333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.241 13.39a.553.553 0 1 1-1.106 0 .553.553 0 0 1 1.106 0zM14.433 12.843h-1.678v.255h1.678v-.255zM14.433 13.3h-1.678v.256h1.678v-.255zM14.433 12.384h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m14.433 12.64-1.678.472v-.255l1.678-.473v.255z",
    fill: "gray"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.433 13.76h-1.678v.256h1.678v-.255zM14.433 14.227h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m14.433 13.098-1.678.472v-.256l1.678-.471v.255zM14.433 13.556l-1.678.473v-.255l1.678-.473v.255zM14.433 14.016l-1.678.472v-.256l1.678-.471v.255z",
    fill: "gray"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.433 11.926h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m14.433 12.181-1.678.473v-.257l1.678-.471v.255z",
    fill: "gray"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 12.843h-1.678v.255h1.678v-.255zM16.28 13.3h-1.678v.256h1.678v-.255zM16.28 12.384h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m16.282 12.64-1.68.472v-.255l1.68-.473v.255z",
    fill: "gray"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 13.76h-1.678v.256h1.678v-.255zM16.28 14.227h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m16.282 13.098-1.68.472v-.256l1.68-.471v.255zM16.282 13.556l-1.68.473v-.255l1.68-.473v.255zM16.282 14.016l-1.68.472v-.256l1.68-.471v.255z",
    fill: "gray"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 11.926h-1.678v.255h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m16.282 12.181-1.68.473v-.257l1.68-.471v.255z",
    fill: "gray"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M20.929 11.935a.858.858 0 0 0-.598-.314l-3.72-.282h-4.184l-3.721.282a.851.851 0 0 0-.746 1.119l.273.823h2.711l1.038 1.17a.817.817 0 0 0 .61.274h3.855c.233 0 .455-.1.61-.274l1.038-1.17h2.711l.273-.823a.849.849 0 0 0-.148-.805h-.002zm-9.016 1.194a.199.199 0 0 1-.319.159l-.966-.73v-.431c0-.092.075-.167.166-.167h.952c.092 0 .167.075.167.167v1.002zm4.493.913c0 .19-.154.347-.347.347h-3.082a.348.348 0 0 1-.348-.347v-1.735c0-.19.155-.347.348-.347h3.082c.19 0 .347.155.347.347v1.735zm2.002-1.484-.967.73a.199.199 0 0 1-.318-.159v-1.002c0-.092.075-.167.167-.167h.951c.092 0 .167.075.167.167v.43z",
    fill: "gray"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9.791 12.767h-.887a.179.179 0 0 0-.178.178v.887c0 .099.08.179.178.179h.887c.099 0 .179-.08.179-.179v-.887a.179.179 0 0 0-.179-.178zM20.13 12.767h-.887a.179.179 0 0 0-.178.178v.887c0 .099.08.179.178.179h.887c.099 0 .179-.08.179-.179v-.887a.179.179 0 0 0-.179-.178z",
    fill: "#4D4D4D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M85.77 8.291H3.265v2.298H85.77V8.29z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.255 10.07V8.809H3.783v1.26h81.472z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M47.257 10.172h2.518c.134 0 .243.109.243.243v1.87a.243.243 0 0 1-.243.244h-2.518a.243.243 0 0 1-.243-.243v-1.87c0-.135.109-.244.243-.244z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.58 10.355h-2.125a.206.206 0 0 0-.206.206v1.578c0 .114.092.206.206.206h2.124a.206.206 0 0 0 .206-.206v-1.578a.206.206 0 0 0-.206-.206z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M50.62 10.172h2.517c.134 0 .243.109.243.243v1.87a.243.243 0 0 1-.243.244h-2.518a.243.243 0 0 1-.243-.243v-1.87c0-.135.109-.244.243-.244z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.941 10.355h-2.124a.206.206 0 0 0-.206.206v1.578c0 .114.093.206.206.206h2.124a.206.206 0 0 0 .206-.206v-1.578a.206.206 0 0 0-.206-.206z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M3.267.031h-.75v8.264h.75V.031zM86.52.031h-.75v8.264h.75V.031z",
    fill: "#757575"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21.822.031H3.012v8.26h18.81V.03z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.398 6.086H3.436v.488h17.962v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.398 6.572H3.436v.489h17.962v-.489z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.398 3.058H3.436v.488h17.962v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.398 3.546H3.436v.488h17.962v-.488z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.398.031H3.436V.52h17.962V.03z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.398.52H3.436v.488h17.962V.52z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44.532.031H21.793v8.26h22.739V.03z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.108 6.086H22.217v.488h21.89v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.108 6.572H22.217v.489h21.89v-.489z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.108 3.058H22.217v.488h21.89v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.108 3.546H22.217v.488h21.89v-.488z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.108.031H22.217V.52h21.89V.03z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.108.52H22.217v.488h21.89V.52z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M67.244.031h-22.74v8.26h22.74V.03z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.82 6.086H44.929v.488h21.89v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82 6.572H44.929v.489h21.89v-.489z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82 3.058H44.929v.488h21.89v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82 3.546H44.929v.488h21.89v-.488z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82.031H44.929V.52h21.89V.03z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82.52H44.929v.488h21.89V.52z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M86.025.031h-18.81v8.26h18.81V.03z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.601 6.086H67.64v.488H85.6v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.601 6.572H67.64v.489H85.6v-.489z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.601 3.058H67.64v.488H85.6v-.488z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.601 3.546H67.64v.488H85.6v-.488z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.601.031H67.64V.52H85.6V.03z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.601.52H67.64v.488H85.6V.52z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M21.804.03h-.02c-.19 0-.343.082-.343.184v8.739c0 .1.154.183.343.183h.02c.189 0 .342-.082.342-.183V.213c0-.1-.153-.183-.342-.183z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.806.03c.189 0 .342.082.342.184v8.74c0 .1-.153.183-.342.183V.03z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M44.513.03h-.02c-.19 0-.343.082-.343.184v8.739c0 .1.154.183.343.183h.02c.189 0 .342-.082.342-.183V.213c0-.1-.153-.183-.342-.183z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.515 9.137V.03c.189 0 .342.082.342.184v8.74c0 .1-.153.183-.342.183z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M67.223.03h-.02c-.19 0-.343.082-.343.184v8.739c0 .1.153.183.343.183h.02c.189 0 .342-.082.342-.183V.213c0-.1-.153-.183-.342-.183z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.225 9.137V.03c.189 0 .342.082.342.184v8.74c0 .1-.153.183-.342.183z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M82.963 9.5h-.252v4.485h.252V9.5z",
    fill: "#CCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M85.506 13.983v-.252h-2.783v.252h2.783zM85.506 12.554v-.252h-2.783v.252h2.783zM85.506 11.126v-.252h-2.783v.252h2.783z",
    fill: "#CCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M85.506 9.5h-.252v4.485h.252V9.5zM3.783 9.5h-.252v4.485h.252V9.5z",
    fill: "#CCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.324 13.985v-.252H3.541v.252h2.783zM6.326 12.556v-.252H3.543v.252h2.783zM6.326 11.126v-.252H3.543v.252h2.783z",
    fill: "#CCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M6.324 9.5h-.252v4.485h.252V9.5z",
    fill: "#CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGondola);
export default __webpack_public_path__ + "static/media/gondola.b42b8762402bc323500aa1facab7fe05.svg";
export { ForwardRef as ReactComponent };